import React from 'react';
import { Hero } from './components/Hero';
import { EarlyTestimonials } from './components/EarlyTestimonials';
import { PainPoints } from './components/PainPoints';
import { ProductPresentation } from './components/ProductPresentation';
import { Tomos } from './components/Tomos';
import { Bonos } from './components/Bonos';
import { EbookIA } from './components/EbookIA';
import { MoreTestimonials } from './components/MoreTestimonials';
import { CountdownUrgency } from './components/CountdownUrgency';
import { ValueTable } from './components/ValueTable';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { ComparisonTable } from './components/ComparisonTable';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { useScreenInit } from './useScreenInit';
export function App() {
  useScreenInit('landing');
  return <main className="w-full min-h-full" style={{
    backgroundColor: '#0A0A0A'
  }} data-id="element-0">
      <Hero data-id="element-1" />
      <EarlyTestimonials data-id="element-2" />
      <PainPoints data-id="element-3" />
      <ProductPresentation data-id="element-4" />
      <Tomos data-id="element-5" />
      <Bonos data-id="element-6" />
      <EbookIA data-id="element-7" />
      <MoreTestimonials data-id="element-8" />
      <CountdownUrgency data-id="element-9" />
      <ValueTable data-id="element-10" />
      <Guarantee data-id="element-11" />
      <FAQ data-id="element-12" />
      <ComparisonTable data-id="element-13" />
      <FinalCTA data-id="element-14" />
      <Footer data-id="element-15" />
    </main>;
}